// RubricaList.jsx
import React, { useState, useContext } from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import api from '../../../services/api'
import RubricaOverlay from './RubricaOverlay'
import '../../../css/rubricaList.css'

const RubricaList = ({ rubrica, refreshRubricaList }) => {
  const { hasPermission } = useContext(AuthContext)
  const [searchTerm, setSearchTerm] = useState('')
  const [visibleCount, setVisibleCount] = useState(20)
  const [success, setSuccess] = useState('')
  const [editingItem, setEditingItem] = useState(null)

  const canEdit = hasPermission('rubrica_edit') || hasPermission('rubrica_edit_own')
  const canDelete = hasPermission('rubrica_destroy') || hasPermission('rubrica_destroy_own')

  const filteredRubrica = rubrica.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.notes && item.notes.toLowerCase().includes(searchTerm.toLowerCase()))
  )

  const toggleVisible = () => {
    if (visibleCount === filteredRubrica.length) {
      setVisibleCount(20)
    } else {
      setVisibleCount(filteredRubrica.length)
    }
  }

  const handleEdit = async (id) => {
    if (!canEdit) return
    try {
      const response = await api.get(`/rubrica/${id}`)
      setEditingItem(response.data)
    } catch (error) {
      console.error('Errore nel caricamento della rubrica:', error)
    }
  }

  const handleDelete = async (id) => {
    if (!canDelete) return
    if (!window.confirm('Sei sicuro di voler eliminare questa rubrica?')) return
    try {
      await api.delete(`/rubrica/${id}`)
      setSuccess('Rubrica eliminata con successo!')
      setTimeout(() => setSuccess(''), 2000)
      if (refreshRubricaList) refreshRubricaList()
    } catch (error) {
      console.error("Errore nell'eliminazione della rubrica:", error)
    }
  }

  const closeOverlay = () => {
    setEditingItem(null)
  }

  return (
    <div className="rubrica-list">
      <div className="rubrica-list-search">
        <input
          type="text"
          placeholder="Cerca rubrica..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="rubrica-search"
        />
      </div>
      {success && <p className="success">{success}</p>}

      <div className="rubrica-list-items">
        {filteredRubrica.slice(0, visibleCount).map(item => (
          <div key={item.id} className="rubrica-card">
            <div className="rubrica-details">
              <h3>{item.name}</h3>
              {item.notes && <p className="rubrica-notes">{item.notes}</p>}
              <div className="rubrica-actions">
                {canEdit && (
                  <button onClick={() => handleEdit(item.id)}>Modifica</button>
                )}
                {canDelete && (
                  <button onClick={() => handleDelete(item.id)}>Elimina</button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredRubrica.length > 20 && (
        <button onClick={toggleVisible} className="redirect-btn">
          {visibleCount === filteredRubrica.length ? 'Mostra meno' : 'Mostra altro'}
        </button>
      )}

      {editingItem && (
        <RubricaOverlay
          item={editingItem}
          onClose={closeOverlay}
          onUpdate={refreshRubricaList}
        />
      )}
    </div>
  )
}

export default RubricaList
